import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrivacyPolicy } from './components/PrivacyPolicy';
import { Header } from './components/Header';

function Policy() {
  return (
    <div className="App">
      <Header />
      <PrivacyPolicy />
    </div>
  );
}

export default Policy;